import React from 'react';

import { graphql } from 'gatsby';
import Layout from '@components/Layout';
import Container from '@atoms/Container';
import PageTitle from '@atoms/PageTitle';
import Subnav from '@blocks/Subnav';
import Breadcrumbs from '@sections/Breadcrumbs';
import RichTextEditorStyles from '@utils/RichTextEditorStyles';
import { useResourcesSubnav } from '@hooks/use-resources-subnav';
import paddingDefault from '../components/utils/paddingDefault';
import Seo from '../components/utils/Seo';
import CtaProvider from "../contexts/franchise/cta-provider";
import { justPTags } from "../components/utils/just-p-tags";
import { truncateHTML } from '@utils/Truncate';
import Link from "../components/primitives/link";

const GlossaryTermPage = ({ data, pageContext }) => {
  const { seo } = data.cmsGlossary;
  const { title, description } = data.cmsGlossaryTerm;
  const resourcesSubnav = useResourcesSubnav();
  // Transform the hook data to match the modular block format:
  const subnavData = { subnav: [resourcesSubnav] };

  return (
    <CtaProvider>
      <Layout>
        <Seo
          title={title}
          description={truncateHTML(justPTags(description), 315)}
          imageUrl={seo?.meta_image?.url}
        />
        <Subnav data={subnavData} />
        <div css={paddingDefault()}>
          <Container css={RichTextEditorStyles}>
            <div css={styles.breadcrumbsWrap}>
              <Breadcrumbs />
            </div>
            <div css={styles.pageTitleWrap}>
              <PageTitle>{title || 'Untitled Glossary Term Page'}</PageTitle>
            </div>
            <div
              css={[RichTextEditorStyles, styles.copy]}
              dangerouslySetInnerHTML={{ __html: description }}
            />
            <Link
              css={styles.backToGlossaryLink}
              to="/resources/glossary">‹ Back To Glossary</Link>
          </Container>
        </div>
      </Layout>
    </CtaProvider>
  )
};

const styles = {
  copy: {
    marginBottom: "3.5rem",
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
    fontWeight: 400,
  },
  pageTitleWrap: {
    marginBottom: "1rem"
  },
  breadcrumbsWrap: {
    display: "none",
    "@media (min-width: 1024px)": {
      display: "block"
    }
  },
  backToGlossaryLink: {
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
    fontWeight: 600
  }
};

export const query = graphql`
  query ($slug: String!) {
    cmsGlossaryTerm(url: { eq: $slug }) {
      title
      url
      description
    }
    cmsGlossary {
      seo {
        meta_image {
          url
        }
      }
    }
  }
`;

export default GlossaryTermPage;